import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import EntityCommentsChat from "@/common/components/Entity/Chat/View/EntityCommentsChat";
import { EntityType, VisualInspectionDto } from "@/core/api/generated/v1";

interface Props {
  visualInspection: VisualInspectionDto;
}

export default function CommentsTabContent({ visualInspection }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock>
        <EntityCommentsChat
          entityId={visualInspection.id!}
          entityType={EntityType.VisualInspection}
          entity={visualInspection}
        />
      </ViewContentBlock>
    </PageTabContent>
  );
}
